<script lang="ts">
  import { Form, Input } from "sveltestrap";
  import { Active, Established } from "../../../../utils/Constant/Constant";
  export let getId: string;
</script>

<div
  class="tab-pane fade {getId === 'profile-info-tab' ? 'show active' : ''} "
  id="profile-info-tab"
>
  <div class="people-list">
    <div class="search">
      <Form class="theme-form">
        <div class="mb-3">
          <Input type="text" placeholder="Write Status..." />
          <i class="fa fa-pencil" />
        </div>
      </Form>
    </div>
  </div>
  <div class="status">
    <p class="font-dark">{Active}</p>
    <hr />
    <p>
      {Established}
      <i class="icofont icofont-emo-heart-eyes font-danger f-20" /><i
        class="icofont icofont-emo-heart-eyes font-danger f-20 m-l-5"
      />
    </p>
    <hr />
    <p>
      Dolore magna aliqua  <i
        class="icofont icofont-emo-rolling-eyes font-success f-20"
      />
    </p>
  </div>
</div>
